// extracted by mini-css-extract-plugin
export default {"container":"Quiz_container__irU-P","content":"Quiz_content__OPHOi","submit":"Quiz_submit__1D5kO","disabled":"Quiz_disabled__CpRIm"};